import React from 'react';

const NoSearchResults = () => {
	return (
		<div className="no-results">
			<p>No results found</p>
		</div>
	);
};

export default NoSearchResults;


// WEBPACK FOOTER //
// ./src/pages/productSearch/NoSearchResults.js